import { useEffect, useRef } from 'react';
import { getSocket }          from '../../socket/socket-client';
import { NOTIFICATION_TYPES } from '../types';

const RELOAD_EVENTS = Object.values(NOTIFICATION_TYPES);

/**
 * Escucha todos los eventos de notificación del socket y llama a `onReload`
 * cada vez que se recibe uno, permitiendo que los listados se refresquen
 * automáticamente sin acoplarse al estado del contexto de notificaciones.
 *
 * Uso:
 *   useNotificationReload(() => setRecargar(prev => !prev));
 */
export function useNotificationReload(onReload) {
  const callbackRef = useRef(onReload);
  callbackRef.current = onReload;

  useEffect(() => {
    let cleanup   = null;
    let intervalId = null;

    const handler = () => callbackRef.current();

    const attach = () => {
      const sock = getSocket();
      if (!sock?.connected) return false;

      RELOAD_EVENTS.forEach(event => {
        sock.off(event, handler);
        sock.on(event, handler);
      });

      cleanup = () => RELOAD_EVENTS.forEach(event => sock.off(event, handler));
      return true;
    };

    if (!attach()) {
      intervalId = setInterval(() => {
        if (attach()) clearInterval(intervalId);
      }, 2000);
    }

    return () => {
      clearInterval(intervalId);
      cleanup?.();
    };
  }, []);
}
